import React from "react";
import PropTypes from "prop-types";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import {
  WHATSAPP_FLOAT_HIDDEN_PATHS,
  WHATSAPP_FLOAT_MESSAGE_ENV,
  WHATSAPP_FLOAT_PHONE,
  WHATSAPP_FLOAT_VISIBLE_PATHS,
  WHATSAPP_FLOAT_VISIBLE_PATHS_ENV,
} from "../constants/whatsappFloat";
import { getMessage } from "../data/locales";
import { buildWhatsAppHref, parseWhatsAppPathList, shouldShowWhatsAppFloat } from "../utils/whatsappFloat";
import "./WhatsAppFloatButton.css";

export default function WhatsAppFloatButton({
  phone = WHATSAPP_FLOAT_PHONE,
  message,
  visiblePaths,
  hiddenPaths = WHATSAPP_FLOAT_HIDDEN_PATHS,
}) {
  const location = useLocation();
  const resolvedVisiblePaths =
    visiblePaths || parseWhatsAppPathList(WHATSAPP_FLOAT_VISIBLE_PATHS_ENV, WHATSAPP_FLOAT_VISIBLE_PATHS);
  const resolvedMessage =
    typeof message === "string" ? message : WHATSAPP_FLOAT_MESSAGE_ENV || getMessage("whatsapp.prefilledMessage");
  const href = buildWhatsAppHref(phone, resolvedMessage);

  if (
    !href ||
    !shouldShowWhatsAppFloat(location.pathname, resolvedVisiblePaths, hiddenPaths)
  ) {
    return null;
  }

  return (
    <a
      className="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={getMessage("whatsapp.floatAriaLabel")}
    >
      <FaWhatsapp aria-hidden="true" className="whatsapp-float__icon" />
    </a>
  );
}

WhatsAppFloatButton.propTypes = {
  phone: PropTypes.string,
  message: PropTypes.string,
  visiblePaths: PropTypes.arrayOf(PropTypes.string),
  hiddenPaths: PropTypes.arrayOf(PropTypes.string),
};
